// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.expandable-description-text {
    font-size: 16px;
    line-height: 22px;
    font-weight: 400;
    color: #6d6b6b;
    margin: 4px 0 0;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
    word-break: break-word;
}

.expandable-description-text.is-expanded {
    display: block;
    -webkit-line-clamp: unset;
    overflow: visible;
}
`, "",{"version":3,"sources":["webpack://./src/features/alumni/alumni-profile/controls/ExpandableDescription.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,eAAe;IACf,oBAAoB;IACpB,4BAA4B;IAC5B,qBAAqB;IACrB,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA;IACI,cAAc;IACd,yBAAyB;IACzB,iBAAiB;AACrB","sourcesContent":[".expandable-description-text {\n    font-size: 16px;\n    line-height: 22px;\n    font-weight: 400;\n    color: #6d6b6b;\n    margin: 4px 0 0;\n    display: -webkit-box;\n    -webkit-box-orient: vertical;\n    -webkit-line-clamp: 2;\n    overflow: hidden;\n    word-break: break-word;\n}\n\n.expandable-description-text.is-expanded {\n    display: block;\n    -webkit-line-clamp: unset;\n    overflow: visible;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
